var ViewService = /** @class */ (function () {
    function ViewService(api) {
        this.API = api;
    }
    ViewService.prototype.getViews = function (appId) {
        var url = '/views';
        if (appId) {
            url += "?app=".concat(appId);
        }
        return this.API.get(url);
    };
    ViewService.prototype.getPaginatedViews = function (appId, page, perPage, sortConfig, filter) {
        var url = '/views';
        if (appId) {
            url += "?app=".concat(appId);
        }
        // page indexes start at 1
        if (page) {
            url += "".concat(appId ? '&' : '?', "page=").concat(page);
            if (perPage) {
                url += "&per_page=".concat(perPage);
            }
        }
        if ((sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.field) && (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.order)) {
            var field = sortConfig.field, order = sortConfig.order;
            url += "".concat(appId || page ? '&' : '?', "sort=").concat(field, ":").concat(order);
        }
        if (filter) {
            url += "".concat(appId || page || sortConfig.field ? '&' : '?', "filter=").concat(filter);
        }
        return this.API.get(url);
    };
    ViewService.prototype.getView = function (viewId, noDraft) {
        var url = "/views/".concat(viewId);
        return this.API.get(url, { noDraft: noDraft });
    };
    ViewService.prototype.createView = function (view, appId) {
        var url = '/views';
        return this.API.post(url, {
            name: view.name,
            type: view.type,
            dataset_type: view.dataset_type,
            background_color: 'unset',
            padding: {
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
            },
            settings: {
                fullscreen: false,
                flow: true,
                hasLandscape: false,
                fontScalingAllowed: false,
            },
            background_image: {
                source: '',
                size: 'cover',
            },
            layout: {},
            inputs: view.inputs || [],
            outputs: [],
            app: appId,
        });
    };
    ViewService.prototype.cloneView = function (appId, name, viewId) {
        var url = "/views/".concat(viewId, "/clone");
        return this.API.post(url, {
            app: appId,
            name: name,
        });
    };
    ViewService.prototype.updateView = function (_a) {
        var name = _a.name, bgColor = _a.bgColor, bgImage = _a.bgImage, padding = _a.padding, savedLayout = _a.savedLayout, inputs = _a.inputs, outputs = _a.outputs, viewId = _a.viewId, settings = _a.settings;
        var url = "/views/".concat(viewId);
        return this.API.patch(url, {
            name: name,
            background_color: bgColor,
            background_image: bgImage,
            padding: padding,
            layout: savedLayout,
            inputs: inputs,
            outputs: outputs,
            settings: settings,
        }, this.API.IS_DRAFTABLE);
    };
    ViewService.prototype.deleteView = function (viewId) {
        var url = "/views/".concat(viewId);
        return this.API.delete(url);
    };
    return ViewService;
}());
export { ViewService };
